import app from "../helpers/appGlobal.js";

const fetchKeys = cb => {
  fetch(`${process.env.PUBLIC_URL}/keys.json`, { cache: "no-cache" })
    .then(response => response.json())
    .then(responseJSON => {
      if (responseJSON) {
        app.config = responseJSON;
        cb();
      }
    });
};

export default fetchKeys;
